import PricingComponent from "../../Components/pricingPage/pricingComponent";
import ProfileNavbar from "../../Components/ProfileNavbar/ProfileNavbar";

export default function Pricing() {

  return (
    <>
      <ProfileNavbar/>
      <PricingComponent/>
    </>
  );
}
